// src/components/Settings/Settings.tsx
import React from 'react';
import "./Settings.css"

interface SettingsProps {
  refreshRate: number;
  onRefreshRateChange: (rate: number) => void;
}

export function Settings({ refreshRate, onRefreshRateChange }: SettingsProps): JSX.Element {
  return (
    <div className='Settings'>
      <label htmlFor="refresh_rate">Refresh Rate (ms): </label>
      <input className='settingsInput'
        type="number"
        id="refresh_rate"
        value={refreshRate}
        onChange={(e) => onRefreshRateChange(parseInt(e.target.value))}
      />
      <span id="refresh_value">{refreshRate}</span>
    </div>
  );
}

export default Settings;
